import { Controller } from "react-hook-form";

import { useEffect, useRef } from "react";
import Labels from "src/app/constants/labels";
import { ImageUpload } from "../../Inputs";
import { useDisabledField } from "../HookForm/HookForm.context";
import { InputImageUploadProps } from "./InputImageUpload.types";

export function InputImageUpload({
  disabled,
  form,
  rule,
  name,
  ...props
}: InputImageUploadProps) {

  const imageUploadRef = useRef<HTMLDivElement | null>();
  const isDisabled = useDisabledField(name);

  useEffect(() => {
    if (form.formState.isSubmitting) {
      const errorKeys = Object.keys(form.formState.errors);
      if (errorKeys.indexOf(name) === 0) {
        imageUploadRef.current?.scrollIntoView();
      }
    }
  }, [form.formState.isSubmitting]);


  return (
    <Controller
      disabled={isDisabled || disabled}
      control={form.control}
      rules={rule}
      name={name}
      render={({ field, fieldState }) => {
        const isError = !!fieldState.error;
        const errorMessage = rule?.required === true
          ? Labels.FIELD_REQUIRED
          : fieldState.error?.message?.toString();
        return (
          <ImageUpload
            {...props}
            form={form}
            name={name}
            onDeleteImage={() => form.setValue(name, undefined)}
            onChangeImage={(_) => field.onChange(_)}
            helperText={isError ? errorMessage : props.helperText}
            required={!!rule?.required}
            disabled={field.disabled}
            value={field.value}
            error={isError}
            ref={(ref) => {
              imageUploadRef.current = ref;
              field.ref(ref);
            }}
          />
        );
      }}
    />
  );
}